export class FetchParishesByCountyIdCommand {
  private _countyId: number

  constructor (countyId: number) {
    this._countyId = countyId
  }

  countyId (): number {
    return this._countyId
  }
}
